// extracted by mini-css-extract-plugin
export var infoItem = "_ol-2";
export var title = "_ol-0";
export var value = "_ol-1";